/** @format */

import validators from './validators';

export default {
  mixins: [validators],
  methods: {
    validateAll: async function (data, silent = false, parent = '', noerror = true) {
      //var noerror = true;
      for (var key in data) {
        if (typeof data[key] === 'object' && data[key] !== null && this.nestedObject.includes(key)) {
          if (await this.validateAll(data[key], silent, key + '.', noerror)) {
          } else {
            noerror = false;
          }
        } else {
          this.errors[parent + key] = null;
          if (await this.validate(parent + key, false)) {
            noerror = false;
          }
        }
      }
      if (!noerror && !parent) {
        if (!silent)
          this.$root.$emit('show-info', {
            text: 'Не верно заполнены поля',
            type: 'error',
          });
        let result = {};
        for (let key in this.errors) {
          if (this.errors[key]) {
            result[key] = this.errors[key];
          }
        }
        //return result;
        console.log('validate Errors', result);
      }
      return noerror;
    },
    validate: async function (key, setChanged = true) {
      if ((this.validators[key] || []).includes('ignoreChange')) {
      } else {
        if (this.loaded === false || !setChanged) {
        } else {
          
          this.$set(this.changedFields, key, true);
          this.isChanged = true;
        }
      }
      const error = await this.validator(this.validators[key], key, this.data);
      this.warnings[key] = '';
      if (error[0] == '@') {
        this.warnings[key] = error.slice(1);
        return (this.errors[key] = '');
      }
      return (this.errors[key] = error);
    },
    validateTask: async function (key) {
      const error = await this.validator(this.validatorsTask[key], key, this.dataTask);
      return (this.errorsTask[key] = error);
    },

    async validateData(data, model, showFieldError = false, returnErrors = false) {
      // console.log('validateData', JSON.parse(JSON.stringify(data)), model);
      let validators = {};
      for (let el of model) {
        if (el.validator) {
          let name = el.name;
          validators[name] = el.validator;
        }
      }
      let errors = {};
      const validate = async (key) => {
        const error = await this.validator(validators[key], key, data);
        return (errors[key] = error);
      };
      const valAll = async (data, parent = '', noerror = true) => {
        for (var key in validators) {
          if (typeof data[key] === 'object' && data[key] !== null && this.nestedObject.includes(key)) {
            if (await valAll(data[key], key + '.', noerror)) {
            } else {
              noerror = false;
            }
          } else {
            errors[parent + key] = null;
            if (await validate(parent + key)) {
              noerror = false;
            }
          }
          if (showFieldError && errors[parent + key]) {
            this.$root.$emit('show-info', {
              text: `${model.find((m) => m.name == key).title} : ${errors[parent + key]}`,
              type: 'error',
            });
          }
        }
        if (!noerror) {
          if (false)
            this.$root.$emit('show-info', {
              text: 'Не верно заполнены поля',
              type: 'error',
            });
          // console.log('validate Errors', this.errors);
        }
        console.log('errors', errors, noerror);
        return noerror;
      };
      if (await valAll(data)) {
        return true;
      }
      if (returnErrors) return errors;
      return false;
    },
  },
};
